import React, { useContext, useEffect, useState } from "react";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import ReactStars from "react-rating-stars-component";
import { Customers } from "../../../utils/apis/homepage/index";
import { Context } from "../../../utils/context";
import { IDS } from "../../../utils/common";
import Common_heading from "../../common/common_heading/Common_heading";

// Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "./What_Customer_Say.css";

const What_Customer_Say = () => {
  const { IMG_URL } = useContext(Context);
  const [customer, setCustomer] = useState([]);

  const HtmlToReactParser = require("html-to-react").Parser;
  const htmlToReactParser = new HtmlToReactParser();

  const getCustomers = async () => {
    const res = await Customers();
    if (res?.success) {
      setCustomer(res.data || []);
    }
  };

  // Array of free, professional, high-quality placeholder avatars
  const RANDOM_AVATARS = [
    "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&auto=format&fit=crop&q=80",
    "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&auto=format&fit=crop&q=80",
    "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&auto=format&fit=crop&q=80",
    "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&auto=format&fit=crop&q=80",
    "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=150&auto=format&fit=crop&q=80",
  ];

  // Simple deterministic or index-based picker so avatars stay persistent per item
  const getRandomAvatar = (index) => {
    return RANDOM_AVATARS[index % RANDOM_AVATARS.length];
  };

  useEffect(() => {
    getCustomers();
  }, []);

  return (
    <section className="deli_testimonials_wrapper">
      <div className="container">
        <Common_heading
          title="What Our Customers Say"
          subtitle="Real experiences from Our Customers"
        />

        <div className="swiper_container_layout">
          <Swiper
            modules={[Navigation]}
            navigation={true}
            slidesPerView={1}
            spaceBetween={30}
            loop={true}
            speed={600}
            breakpoints={{
              768: { slidesPerView: 2, spaceBetween: 30 },
              1200: { slidesPerView: 3, spaceBetween: 40 },
            }}
            className="deli_swiper"
          >
            {customer.map((item, index) => (
              <SwiperSlide key={item.id || item._id || index}>
                <div className="deli_testimonial_card">
                  {/* Styled Light Blue Cyan Quote Icon Frame */}
                  <div className="card_quote_icon">“</div>

                  {/* Profile Avatar Frame */}
                  <div className="avatar_wrapper">
                    <img
                      src={IDS?.IMG_URL + item?.image}
                      alt={item.name || "Client"}
                      className="user_avatar"
                      // onError={(e) => {
                      //   // Safe fallback if your API image returns a 404 broken link
                      //   e.target.src = getRandomAvatar(index);
                      // }}
                    />
                  </div>

                  {/* Review Text Body */}
                  <div className="review_text_body clamp-4">
                    {htmlToReactParser.parse(item.description)}
                  </div>

                  {/* Star Rating Grid */}
                  <div className="stars_box_alignment">
                    <ReactStars
                      count={5}
                      value={Number(item?.rating) || 5}
                      edit={false}
                      size={20}
                      activeColor="#38bdf8"
                    />
                  </div>

                  {/* Meta Client Footer */}
                  <h5 className="client_title_name">{item.name}</h5>
                  <span className="client_sub_role">Verified Client</span>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default What_Customer_Say;
